const Navbar = () => {
  return (
    <nav>
      <div className="bar">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="logo">Notes</div>
    </nav>
  );
};

export default Navbar;
